module.exports = __webpack_public_path__ + "static/media/musical-linguistics.c4f0a31f.gif";